import { linkToPatient } from "$routes/patient/links";

export function linkToNewVaccination(opts: { patientUuid?: string } = {}) {
  return `${linkToPatient()}/vaccinations/new${
    opts.patientUuid ? `?patientUuid=${opts.patientUuid}` : ""
  }`;
}

export function linkToReviewVaccination(opts: { patientUuid?: string } = {}) {
  return `${linkToPatient()}/vaccinations/review${
    opts.patientUuid ? `?patientUuid=${opts.patientUuid}` : ""
  }`;
}
